import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './MetalMarketHeader.vue'
import Sidebar from './Sidebar.vue'
import Switch from './Switch.vue'
import Announcement from './Announcement.vue'

export {
  Aside,
  Breadcrumb,
  Callout,
  Footer,
  Header,
  Sidebar,
  Switch,
  Announcement
}



// WEBPACK FOOTER //
// ./src/components/index.js